import { SxProps, Theme, Typography } from '@mui/material';
import React, { ReactElement } from 'react';

export interface FormErrorsProps {
  children?: string[] | string | undefined | false;
  sx?: SxProps<Theme>;
}

export const FormErrors = ({
  children,
  sx,
}: FormErrorsProps): ReactElement | null => {
  let message = '\u00a0';

  if (children)
    message = typeof children === 'string' ? children : children.join('\n');

  return (
    <Typography
      sx={{
        whiteSpace: 'pre',
        color: theme => theme.palette.error.main,
        width: 0,
        overflow: 'visible',
        fontSize: { xs: 12, md: 14 },
        ...sx,
      }}
    >
      {message}
    </Typography>
  );
};
